export default __webpack_public_path__ + "static/media/pwd_type1.dc5d3650.png";